import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Footer from './compo/Footer/Footer';
import Navbar from './compo/Navbar/Navbar';
import About from './page/About/About';
import CategoryPage from './page/CategoryPage/CategoryPage';
import Contact from './page/Contact.js/Contact';
import Customers from './page/customers/Customers';
import Home from './page/Home/Home';
import ProductCC from './page/ProductCC/ProductCC';
import ProductDetail from './page/ProductDetail/ProductDetail';
import Product from './page/Products/Product';

function App() {
  return (
    <>
      <BrowserRouter>
      <Navbar/>
        <Routes>
          <Route path="/" element={<Home />}/>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="product" element={<Product />} />
            <Route path="/category/:categoryName" element={<CategoryPage/>} />
            <Route path="/product/:id" element={<ProductDetail/>} />
            <Route path="/customer" element={<Customers/>} />
            <Route path="/contact" element={<Contact/>} />
            <Route path="/proo/:productName" element={<ProductCC/>} />
        </Routes>
        <Footer/>
      </BrowserRouter>
    </>
  );
}

export default App;
